(function () {
  // Fallback for browsers without IntersectionObserver support
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.animate').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    }
  );

  function observeAll() {
    document.querySelectorAll('.animate:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  observeAll();

  // Re-observe after Shopify theme editor section reloads
  document.addEventListener('shopify:section:load', observeAll);
})();
